import React from 'react';

import SuggestionLabel from './SuggestionLabel';
import SuggestionInput from './SuggestionInput';
import SuggestionText from './SuggestionText';

export default ({ className, onChange, isChosen, value, label }) => (
  <SuggestionLabel className={className} isChosen={isChosen}>
    <SuggestionInput type="radio" name="address_suggestion" value={value} onChange={() => onChange(value)} />
    <SuggestionText isChosen={isChosen}>{label}</SuggestionText>
  </SuggestionLabel>
);
